// India Standard Time "today" for the dashboards: the date shown and the day's figures switch at 00:00 IST,
// whatever the PC's own clock / time zone is set to.
import { useEffect, useState } from "react";

const IST_OFFSET_MS = 330 * 60 * 1000;
export const istDayKey = () => new Date(Date.now() + IST_OFFSET_MS).toISOString().slice(0, 10); // YYYY-MM-DD in IST
export const istLongDate = () => new Date().toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata", weekday: "long", day: "numeric", month: "long", year: "numeric" });
const msToIstMidnight = () => {
  const ist = Date.now() + IST_OFFSET_MS;
  return 86400000 - (ist % 86400000) + 500; // just after 00:00 IST
};

/** Returns today's IST date (YYYY-MM-DD); re-renders at 00:00 IST, and when the PC wakes / the tab comes back. */
export function useIstToday() {
  const [day, setDay] = useState(istDayKey);
  useEffect(() => {
    let timer;
    const schedule = () => { timer = setTimeout(() => { setDay(istDayKey()); schedule(); }, msToIstMidnight()); };
    const check = () => setDay(istDayKey());
    schedule();
    const minute = setInterval(check, 60000); // also catches sleep / hibernate over midnight
    document.addEventListener("visibilitychange", check);
    return () => { clearTimeout(timer); clearInterval(minute); document.removeEventListener("visibilitychange", check); };
  }, []);
  return day;
}
